<template>
  <div>
    <h1 class="page-header">{{ $t('monthlyOvertime.pageTitle') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <ts-button color="info" outline @click="showForm()">
              {{ $t('addNew') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-2 col-lg-2">
            <ts-date-picker-input readonly v-model="year" format="YYYY"> </ts-date-picker-input>
          </div>
          <div class="col-sm-12 col-md-2 col-lg-2">
            <ts-date-picker-input readonly format="MM" v-model="month"> </ts-date-picker-input>
          </div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record, index }">
          <td>{{ record.employee.employee_name_en }}</td>
          <td>{{ record.ot_date }}</td>
          <td>{{ record.time_from }}</td>
          <td>{{ record.time_to }}</td>
          <td class="text-center">{{ record.break }}</td>
          <td>{{ record.remarks }}</td>
          <td class="text-center">
            <a href="#" v-tooltip="'Edit'" class="text-primary mr-2" @click.prevent="edit(record)">
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="'Delete'"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fa fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import FormComponent from './form'
import { debounce } from 'lodash'

export default {
  name: 'monthly-overtime',
  components: {
    FormComponent
  },
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/monthlyOvertime', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.monthlyOvertime.search
      },
      set(newValue) {
        this.$store.commit('hr/monthlyOvertime/SET_SEARCH', newValue)
        this.$store.commit('hr/monthlyOvertime/RESET_CURRENT_PAGE')
      }
    },
    year: {
      get() {
        return this.$store.state.hr.monthlyOvertime.year
      },
      set(val) {
        this.$store.commit('hr/monthlyOvertime/SET_YEAR', val)
      }
    },
    month: {
      get() {
        return this.$store.state.hr.monthlyOvertime.month
      },
      set(val) {
        this.$store.commit('hr/monthlyOvertime/SET_MONTH', val)
      }
    },
    columns() {
      return [
        {
          name: this.$t('monthlyOvertime.employeeName')
        },
        {
          name: this.$t('monthlyOvertime.otDate')
        },
        {
          name: this.$t('monthlyOvertime.timeFrom')
        },
        {
          name: this.$t('monthlyOvertime.timeTo')
        },
        {
          name: this.$t('monthlyOvertime.break'),
          style: 'width:7%; text-align:center'
        },
        {
          name: this.$t('monthlyOvertime.remark')
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 7%;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/monthlyOvertime/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '40%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    edit(record) {
      this.showForm(record)
    },
    async destroy(record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('hr/monthlyOvertime/destroy', record.record_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    year: function() {
      this.fetchData()
    },
    month: function() {
      this.fetchData()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/monthlyOvertime/RESET_STATE')
    next()
  }
}
</script>
